exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._321wV9vGtFnruJfZjqsl_z{color:\"[theme:neutralSecondary, default:#666666]\";font-size:24px}", ""]);

// exports
exports.locals = {
	"icon": "_321wV9vGtFnruJfZjqsl_z"
};